import {get} from "../../api"
import * as url from "../../url"

const apiGetEnumStoragesList = data => {
  return get(url.API_ENUM_STORAGES, data.history)
}

export {
  apiGetEnumStoragesList,
}
